export default __webpack_public_path__ + "static/media/profile.f59fa003.gif";